export default {
  order_status_toast: {
    order_reviewed: '#{{number}} Tu pedido ha sido visto',
    order_confirmed: '#{{number}} Hora confirmada {{time}}',
    order_preparation_up_time_changed: '#{{number}} Hora de {{type}} cambiada a {{time}}',
    serving_time_changed: '#{{number}} Tu pedido se servirá a las {{time}}',
    order_preparing: 'Tu pedido #{{number}} está siendo preparado',
    order_rejected: 'Pedido #{{number}} rechazado',
  },
  order_type: {
    pickup: 'Recogida',
    delivery: 'Entrega',
  },
};
